module.exports = __webpack_public_path__ + "img/38.f31fcdfa.jpg";